import { RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import { useDetailTableHandlers as useCommonDetailTableHandlers } from "src/hooks/useDetailTableHandlers";
import { useCodeSearch } from "src/hooks/useCodeSearch";
import { createModuleConfig } from "src/utils/detail-table/detailTableUtils";
import { calculateDetailAmount } from "src/utils/calculation/calculationUtils";
import { SAL2020_R01DetailDto } from "../Dto_SAL2020_R01";

interface UseSAL2020_R01CellChangeProps {
	SAL2020_R01DetailList: SAL2020_R01DetailDto[];
	originalSAL2020_R01DetailList: SAL2020_R01DetailDto[];
	updateSAL2020_R01DetailList: (index: number, data: SAL2020_R01DetailDto) => void;
	gridRef: RefObject<AgGridReact<SAL2020_R01DetailDto> | null>;
	setCodeSearchModalProps: any;
}

export function useSAL2020_R01CellChange({
	SAL2020_R01DetailList,
	originalSAL2020_R01DetailList,
	updateSAL2020_R01DetailList,
	gridRef,
	setCodeSearchModalProps,
}: UseSAL2020_R01CellChangeProps) {
	const { searchExactCode } = useCodeSearch({});
	const SAL2020R01Config = createModuleConfig.SAL2020();

	const fieldConfigWithSearch = {
		...SAL2020R01Config.fieldConfig,
		codeSearchFields: {
			...SAL2020R01Config.fieldConfig.codeSearchFields,
			itemCd: {
				...SAL2020R01Config.fieldConfig.codeSearchFields!.itemCd,
				searchFunction: (code: string, onSuccess?: (item: any) => void) =>
					searchExactCode("item", code, onSuccess),
			},
		},
	};

	const SAL2020_FIELD_MAPPING = {
		qtyField: "salesQty",
		priceField: "salesPrice",
		dcField: "dcAmt",
		amountField: "itemAmt",
		preventNegative: true,
	};

	const calculateAmount = (data: SAL2020_R01DetailDto): SAL2020_R01DetailDto =>
		calculateDetailAmount(data, SAL2020_FIELD_MAPPING);

	const detailTableHandlers = useCommonDetailTableHandlers<SAL2020_R01DetailDto>({
		detailList: SAL2020_R01DetailList,
		updateDetailList: updateSAL2020_R01DetailList,
		originalDetailList: originalSAL2020_R01DetailList,
		setCodeSearchModalProps,
		gridRef,
		fieldConfig: fieldConfigWithSearch,
		codeSearchConfig: SAL2020R01Config.codeSearchConfig,
		calculateAmount,
	});

	return {
		...detailTableHandlers,
		calculateAmount,
	};
}
